import {
  Box,
  Button,
  Checkbox,
  FormControl,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ClearIcon from "@mui/icons-material/Clear";

const fieldSx = { bgcolor: "#fff", "& .MuiOutlinedInput-root": { borderRadius: 2 } };

const DateField = ({ label, value, onChange }) => (
  <TextField
    size="small"
    type="date"
    label={label}
    InputLabelProps={{ shrink: true }}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    sx={fieldSx}
  />
);

const BranchFilterSelect = ({ branches, value, onChange }) => (
  <FormControl size="small" sx={{ minWidth: 200 }}>
    <InputLabel>סניף</InputLabel>
    <Select
      multiple
      value={value}
      onChange={(e) => onChange(typeof e.target.value === "string" ? e.target.value.split(",") : e.target.value)}
      label="סניף"
      renderValue={(selected) => selected.join(", ")}
      sx={{ bgcolor: "#ffffff", borderRadius: 2 }}
    >
      {branches.map((branch) => (
        <MenuItem key={branch} value={branch}>
          <Checkbox size="small" checked={value.includes(branch)} />
          <ListItemText primary={branch} />
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

const SearchField = ({ value, onChange }) => (
  <TextField
    size="small"
    placeholder="חיפוש לפי מס' הזמנה או שם לקוח"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon fontSize="small" sx={{ color: "#9ca3af" }} />
        </InputAdornment>
      ),
    }}
    sx={{ minWidth: 240, ...fieldSx }}
  />
);

// filter = the object returned by useOrdersFilter.
const OrdersFilterBar = ({ filter }) => (
  <Box
    mb={2.5}
    p={2}
    display="flex"
    alignItems="center"
    flexWrap="wrap"
    gap={1.5}
    sx={{ bgcolor: "#f8fafc", border: "1px solid rgba(0,0,0,0.08)", borderRadius: 2 }}
  >
    <Box display="flex" alignItems="center" gap={0.75} sx={{ color: "#0054A5" }}>
      <FilterAltIcon fontSize="small" />
      <Typography variant="body2" fontWeight={700}>
        סינון
      </Typography>
    </Box>
    <SearchField value={filter.values.searchText} onChange={filter.setters.setSearchText} />
    <DateField label="אספקה מתאריך" value={filter.values.dueDateFrom} onChange={filter.setters.setDueDateFrom} />
    <DateField label="אספקה עד תאריך" value={filter.values.dueDateTo} onChange={filter.setters.setDueDateTo} />
    <BranchFilterSelect
      branches={filter.availableBranches}
      value={filter.values.branchFilter}
      onChange={filter.setters.setBranchFilter}
    />
    {filter.hasActiveFilters && (
      <Button
        size="small"
        startIcon={<ClearIcon fontSize="small" />}
        onClick={filter.clearFilters}
        sx={{ textTransform: "none", fontWeight: 600, color: "#dc2626", "&:hover": { bgcolor: "#fef2f2" } }}
      >
        נקה סינון
      </Button>
    )}
  </Box>
);

export default OrdersFilterBar;
